import registerConstants from '../../register/constants/register-constants';

const filter_user_types = {
  trader: {
    label: 'AFFILIATE_SUMMARY.TRADERS',
    value: 'T',
  },
  partner: {
    label: 'AFFILIATE_SUMMARY.PARTNERS',
    value: 'P',
  },
};

const activity_summary_table = [
  {
    header: 'DASHBOARD.SALES_FUNNEL',
    id: 'sales_funnel',
    columns: [
      {
        title: 'AFFILIATE_SUMMARY.COMMISSION_EARNED',
        column: 'commission_earned',
        round: 2,
        prefix: '$',
        forbidden_user_types: [registerConstants.user_types.ifs_type],
      },
      {
        title: 'AFFILIATE_SUMMARY.DEMO_REFERRALS_COUNT',
        column: 'demo_referrals_count',
      },
      {
        title: 'AFFILIATE_SUMMARY.LIVE_REFERRALS_COUNT',
        column: 'live_referrals_count',
      },
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_COUNT',
        column: 'referrals_count',
      },
    ],
  },
  {
    header: 'DASHBOARD.ACHIEVEMENTS',
    id: 'achievements',
    columns: [
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_DEPOSIT_COUNT',
        column: 'referrals_deposited_count',
      },
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_DEPOSITED_SUM',
        column: 'referrals_deposited_sum',
        round: 2,
        prefix: '$',
      },
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_TRADE_COUNT',
        column: 'referrals_trades_count',
      },
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_TRADE_LOTS',
        column: 'referrals_lots',
      },
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_WITHDRAWN_COUNT',
        column: 'referrals_withdrawn_count',
      },
      {
        title: 'AFFILIATE_SUMMARY.REFERRALS_WITHDRAWN_SUM',
        column: 'referrals_withdrawn_sum',
        round: 2,
        prefix: '$',
      },
    ],
  },
];

const b2b_dashboard_items = [
  {
    label: 'B2B_DASHBOARD.REFERRALS_COUNT',
    field: 'referrals_count',
    icon: 'glyphicon glyphicon-user',
  },
  {
    label: 'B2B_DASHBOARD.DEMO_REFERRALS_COUNT',
    field: 'demo_referrals_count',
    icon: 'glyphicon glyphicon-user',
    color: '#4C4D6A',
    title: 'Demo Users',
    is_register_chart: true,
  },
  {
    label: 'B2B_DASHBOARD.LIVE_REFERRALS_COUNT',
    field: 'live_referrals_count',
    icon: 'glyphicon glyphicon-user',
    color: '#1d1e37',
    title: 'Live Users',
    is_register_chart: true,
  },
  {
    label: 'B2B_DASHBOARD.COMMISSION_EARNED',
    field: 'commission_earned',
    round: 2,
    icon: 'glyphicon glyphicon-usd',
  },
  {
    label: 'B2B_DASHBOARD.REFERRALS_DEPOSIT_COUNT',
    field: 'referrals_deposited_count',
    icon: 'glyphicon glyphicon-plus',
  },
  {
    label: 'B2B_DASHBOARD.REFERRALS_DEPOSITED_SUM',
    field: 'referrals_deposited_sum',
    round: 2,
    icon: 'glyphicon glyphicon-usd',
    is_cashier_chart: true,
    title: 'Total Deposit Sum',
    color: '#1d1e37',
  },
  {
    label: 'B2B_DASHBOARD.REFERRALS_TRADE_COUNT',
    field: 'referrals_trades_count',
    icon: 'glyphicon glyphicon-transfer',
    title: 'Trades Count',
    is_trade_chart: true,
    color: '#4C4D6A',
  },
  {
    label: 'B2B_DASHBOARD.REFERRALS_TRADE_VOLUME',
    field: 'referrals_trades_volume',
    round: 2,
    icon: 'glyphicon glyphicon-sort',
    title: 'Trades Volume',
    is_trade_chart: true,
    color: '#1d1e37',
  },
  {
    label: 'B2B_DASHBOARD.REFERRALS_WITHDRAWN_COUNT',
    field: 'referrals_withdrawn_count',
    icon: 'glyphicon glyphicon-minus',
  },
  {
    label: 'B2B_DASHBOARD.REFERRALS_WITHDRAWN_SUM',
    field: 'referrals_withdrawn_sum',
    round: 2,
    icon: 'glyphicon glyphicon-usd',
    is_cashier_chart: true,
    title: 'Total Withdrawn Sum',
    color: '#4C4D6A',
  },
];

const quick_links_form = 'quickLinksForm';

export default {
  filter_user_types,
  activity_summary_table,
  b2b_dashboard_items,
  quick_links_form,
};



// WEBPACK FOOTER //
// ./src/app/main/dashboard/constants/dashboard-constants.js